import { EBizCode } from '/@/types'
import EventBus from '/@/event-bus'
import newStore, { useMyStore } from '/@/store'

// 缓存store实例
let store: ReturnType<typeof useMyStore> | null = null

/**
 * 初始化消息处理器
 * @param storeInstance store实例
 */
export function initMessageHandler (
  storeInstance: ReturnType<typeof useMyStore>,
) {
  store = storeInstance
}

/**
 * 处理WebSocket消息的函数
 * @param payload WebSocket消息负载
 */
export async function handleMessage (payload: any) {
  // console.log('message', payload.data)

  if (!payload || (!store && !newStore)) {
    return
  }

  switch (payload.biz_code) {
    case EBizCode.GatewayOsd: {
      store
        ? store.commit('SET_GATEWAY_INFO', payload.data)
        : newStore.commit('SET_GATEWAY_INFO', payload.data)
      break
    }
    case EBizCode.DeviceOsd: {
      store
        ? store.commit('SET_DEVICE_INFO', payload.data)
        : newStore.commit('SET_DEVICE_INFO', payload.data)
      break
    }
    case EBizCode.DockOsd: {
      store
        ? store.commit('SET_DOCK_INFO', payload.data)
        : newStore.commit('SET_DOCK_INFO', payload.data)
      break
    }
    case EBizCode.MapElementCreate: {
      store
        ? store.commit('SET_MAP_ELEMENT_CREATE', payload.data)
        : newStore.commit('SET_MAP_ELEMENT_CREATE', payload.data)
      break
    }
    case EBizCode.MapElementUpdate: {
      store
        ? store.commit('SET_MAP_ELEMENT_UPDATE', payload.data)
        : newStore.commit('SET_MAP_ELEMENT_UPDATE', payload.data)
      break
    }
    case EBizCode.MapElementDelete: {
      store
        ? store.commit('SET_MAP_ELEMENT_DELETE', payload.data)
        : newStore.commit('SET_MAP_ELEMENT_DELETE', payload.data)
      break
    }
    case EBizCode.DeviceOnline: {
      store
        ? store.commit('SET_DEVICE_ONLINE', payload.data)
        : newStore.commit('SET_DEVICE_ONLINE', payload.data)
      break
    }
    case EBizCode.DeviceOffline: {
      store
        ? store.commit('SET_DEVICE_OFFLINE', payload.data)
        : newStore.commit('SET_DEVICE_OFFLINE', payload.data)
      break
    }
    case EBizCode.FlightTaskProgress:
    case EBizCode.FlightTaskMediaProgress:
    case EBizCode.FlightTaskMediaHighestPriority: {
      EventBus.emit('flightTaskWs', payload)
      break
    }
    case EBizCode.DeviceHms: {
      store
        ? store.commit('SET_DEVICE_HMS_INFO', payload.data)
        : newStore.commit('SET_DEVICE_HMS_INFO', payload.data)
      break
    }
    case EBizCode.DeviceReboot:
    case EBizCode.DroneOpen:
    case EBizCode.DroneClose:
    case EBizCode.CoverOpen:
    case EBizCode.CoverClose:
    case EBizCode.PutterOpen:
    case EBizCode.PutterClose:
    case EBizCode.ChargeOpen:
    case EBizCode.ChargeClose:
    case EBizCode.DeviceFormat:
    case EBizCode.DroneFormat: {
      store
        ? store.commit('SET_DEVICES_CMD_EXECUTE_INFO', {
          biz_code: payload.biz_code,
          timestamp: payload.timestamp,
          ...payload.data,
        })
        : newStore.commit('SET_DEVICES_CMD_EXECUTE_INFO', {
          biz_code: payload.biz_code,
          timestamp: payload.timestamp,
          ...payload.data,
        })
      break
    }
    case EBizCode.ControlSourceChange:
    case EBizCode.FlyToPointProgress:
    case EBizCode.TakeoffToPointProgress:
    case EBizCode.JoystickInvalidNotify:
    case EBizCode.DrcStatusNotify: {
      EventBus.emit('droneControlWs', payload)
      break
    }
    case EBizCode.FlightAreasSyncProgress: {
      EventBus.emit('flightAreasSyncProgressWs', payload.data)
      break
    }
    case EBizCode.FlightAreasDroneLocation: {
      EventBus.emit('flightAreasDroneLocationWs', payload)
      break
    }
    case EBizCode.FlightAreasUpdate: {
      EventBus.emit('flightAreasUpdateWs', payload.data)
      break
    }
    case EBizCode.CameraPhotoTakeProgress: {
      store
        ? store.commit('CAMERA_PHOTO_TAKE_PROGRESS', payload.data)
        : newStore.commit('CAMERA_PHOTO_TAKE_PROGRESS', payload.data)
      break
    }
    default:
      break
  }
}
